

// 日期格式化
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export function parseTime(time, pattern) {
    let d = time;
    if (pattern) {
        d = new Date(time).Format(pattern);
    } else {
        d = new Date(time).Format("yyyy-MM-dd hh:mm:ss");
    }
    return d;
}

export function to_f(x) {
    let f_x1 = parseFloat(x);
    if (isNaN(f_x1)) {
        //alert('统计出错！');
        return "--";
    } else {

        let f_x = Math.round(x * 100) / 100;
        let s_x = f_x.toString();
        let pos_decimal = s_x.indexOf('.');
        if (pos_decimal < 0) {
            pos_decimal = s_x.length;
            s_x += '.';
        }
        while (s_x.length <= pos_decimal + 2) {
            s_x += '0';
        }
        return s_x;
    }
}

export function order_status(v) {
    let rr = v;
    if (localStorage.baseInfo) {
        let obj = JSON.parse(localStorage.baseInfo);
        if (obj.web_order_staus) {
            let ary = obj.web_order_staus;
            for (let i = 0; i < ary.length; i++) {
                if (ary[i].dictValue == v) {
                    rr = ary[i].dictLabel;
                    break;
                }
            }
        }
    }
    return rr;
}

export function getTotalPages(totals, pageSize) {
    return Math.ceil(totals / pageSize) || 1;
}